import tw, { styled } from "twin.macro";

const Error = styled.span([tw`text-sm text-red-500`]);

export default Error;
